import React, { memo } from 'react';
import { useAppContext } from 'src/components/app-context';

import { ButtonIcon, ButtonText } from '@prisjakt/ui/button/variants';
import { IconCompare } from '@prisjakt/ui/icon/compare';
import { DesktopOnly, MediumDown } from 'src/ui/block';
import { TooltipPlacement } from '../tooltip-new';

import * as S from './styles';

type Props = {
  active: boolean;
  activate: () => void;
  className?: string;
  deactivate: () => void;
  showTitle?: boolean;
};

const CompareProductsToggle = ({
  active,
  activate,
  className,
  deactivate,
  showTitle = true,
}: Props) => {
  const { t } = useAppContext();
  const label = active
    ? t('product', 'product-compare.cancel-compare')
    : t('product', 'product-compare.choose-products');

  return (
    <S.Tooltip
      placement={TooltipPlacement.LEFT}
      title={label}
      className={className}
    >
      <MediumDown>
        <S.CompareProductButtonMobile
          ariaLabel={label}
          onClick={active ? deactivate : activate}
          $selected={active}
        >
          <ButtonIcon>
            <IconCompare size={24} />
          </ButtonIcon>
          {showTitle && (
            <ButtonText>{t('product', 'product-compare.compare')}</ButtonText>
          )}
        </S.CompareProductButtonMobile>
      </MediumDown>
      <DesktopOnly>
        <S.CompareProductButtonDesktop
          onClick={active ? deactivate : activate}
          aria-label={label}
        >
          <S.CompareIconWrapper active={active}>
            <IconCompare size={24} />
          </S.CompareIconWrapper>
        </S.CompareProductButtonDesktop>
      </DesktopOnly>
    </S.Tooltip>
  );
};

export default memo(CompareProductsToggle);
